import { ICaseSearchModel } from '../../interfaces/ICase';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetCaseListCountKey = 'get-case-list-count';

export const useGetCaseListCount = (searchModel: ICaseSearchModel, enabled: boolean) => {
    const zoneContext = useZoneContext();
    return useQuery({
        queryKey: [useGetCaseListCountKey, searchModel],
        queryFn: async () => {
            const response = await zoneContext.zoneApiClient.getCaseCount(searchModel);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response.httpResponse.ok) {
                throw new Error(response.errorMessage ?? 'Failed to retrieve the case list count');
            }

            return response.payload?.data;
        },
        keepPreviousData: true,
        enabled: enabled && !!searchModel,
        cacheTime: 0,
        staleTime: 0,
    });
};
